export type FirmwareVersion = {
  major: number;
  minor: number;
  patch: number;
  type: string;
};
